import React from "react";
import { LAYOUTS } from "./index";
import layoutSvgs from "../../utils/layoutSvgs.json";

const LayoutSelector = ({ activeLayout, onLayoutChange }) => {
  const layoutIcons = Object.keys(LAYOUTS).map((id) => ({
    id,
    ...(layoutSvgs[id] || {}),
  }));

  return (
    <div className="layout-selector">
      {layoutIcons.map((layout) => (
        <button
          key={layout.id}
          className={`layout-svg-btn ${
            activeLayout === layout.id ? "active" : ""
          }`}
          onClick={() => onLayoutChange(layout.id)}
          type="button"
          title={layout.id}
        >
          <svg
            viewBox={layout.viewBox || "0 0 64 80"}
            width="41"
            height="54"
            xmlns="http://www.w3.org/2000/svg"
          >
            {(layout.elements || []).map((el, i) => {
              if (el.type === "rect") {
                return (
                  <rect
                    key={i}
                    x={el.x}
                    y={el.y}
                    width={el.width}
                    height={el.height}
                    rx={el.rx}
                    ry={el.ry}
                    fill={el.fill || "none"}
                    stroke={el.stroke || "none"}
                    strokeWidth={el.strokeWidth || 1}
                    opacity={el.opacity}
                  />
                );
              }
              if (el.type === "path") {
                return (
                  <path
                    key={i}
                    d={el.d}
                    stroke={el.stroke || "none"}
                    strokeWidth={el.strokeWidth || 1}
                    fill={el.fill || "none"}
                    opacity={el.opacity}
                  />
                );
              }
              if (el.type === "circle") {
                return (
                  <circle
                    key={i}
                    cx={el.cx}
                    cy={el.cy}
                    r={el.r}
                    fill={el.fill || "none"}
                    stroke={el.stroke || "none"}
                    strokeWidth={el.strokeWidth || 1}
                    opacity={el.opacity}
                  />
                );
              }
              return null;
            })}
          </svg>
        </button>
      ))}
    </div>
  );
};

export default LayoutSelector;